import React from "react";

export default function PlusIcon({ color = "white" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_193_3158)">
        <path
          d="M8.00013 5.33324V10.6666M5.33346 7.9999H10.6668M2.5668 5.74657C2.46949 5.30825 2.48443 4.85246 2.61023 4.42146C2.73604 3.99046 2.96863 3.5982 3.28644 3.28105C3.60425 2.9639 3.997 2.73213 4.42827 2.60723C4.85953 2.48233 5.31535 2.46835 5.75346 2.56657C5.9946 2.18944 6.3268 1.87907 6.71943 1.66409C7.11206 1.44911 7.55249 1.33643 8.00013 1.33643C8.44776 1.33643 8.8882 1.44911 9.28083 1.66409C9.67346 1.87907 10.0057 2.18944 10.2468 2.56657C10.6856 2.46792 11.1422 2.48184 11.5741 2.60704C12.0061 2.73225 12.3994 2.96466 12.7174 3.28267C13.0354 3.60068 13.2678 3.99395 13.393 4.4259C13.5182 4.85786 13.5321 5.31446 13.4335 5.75324C13.8106 5.99438 14.121 6.32657 14.3359 6.7192C14.5509 7.11183 14.6636 7.55227 14.6636 7.9999C14.6636 8.44754 14.5509 8.88797 14.3359 9.2806C14.121 9.67323 13.8106 10.0054 13.4335 10.2466C13.5317 10.6847 13.5177 11.1405 13.3928 11.5718C13.2679 12.003 13.0361 12.3958 12.719 12.7136C12.4018 13.0314 12.0096 13.264 11.5786 13.3898C11.1476 13.5156 10.6918 13.5305 10.2535 13.4332C10.0126 13.8118 9.68018 14.1235 9.28688 14.3394C8.89358 14.5554 8.45215 14.6686 8.00346 14.6686C7.55478 14.6686 7.11335 14.5554 6.72004 14.3394C6.32674 14.1235 5.99429 13.8118 5.75346 13.4332C5.31535 13.5315 4.85953 13.5175 4.42827 13.3926C3.997 13.2677 3.60425 13.0359 3.28644 12.7188C2.96863 12.4016 2.73604 12.0093 2.61023 11.5783C2.48443 11.1473 2.46949 10.6916 2.5668 10.2532C2.18677 10.0127 1.87374 9.68002 1.65683 9.28605C1.43992 8.89207 1.32617 8.44964 1.32617 7.9999C1.32617 7.55016 1.43992 7.10773 1.65683 6.71376C1.87374 6.31979 2.18677 5.98707 2.5668 5.74657Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_193_3158">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}
